import SystemAnnouncementDTO from "@/dto/system/SystemAnnouncementDTO";
import TopNotificationDTO from "@/dto/system/TopNotificationDTO";
import httpClient from "../http/mainServerClient";

export function getSystemAnnouncements({
    pageNo = 1,
    pageSize = 6,
}): Promise<{ items: SystemAnnouncementDTO[]; totalCount: number }> {
    return httpClient.get("/system/announcement/list", { pageNo, pageSize });
}

/**
 * 获取最新的系统公告
 */
export function getLatestSystemAnnouncements(): Promise<SystemAnnouncementDTO[]> {
    return httpClient.get("/system/announcement/latest");
}

/**
 * 获取指定ID公告
 */
export function getSystemAnnouncementById(id: number): Promise<SystemAnnouncementDTO> {
    return httpClient.get(`/admin/system/announcement/${id}`);
}

/**
 * 添加系统公告
 */
export function addSystemAnnouncement(
    data: Pick<SystemAnnouncementDTO, "linkUrl" | "title" | "excludedShopTypes">,
): Promise<SystemAnnouncementDTO> {
    return httpClient.post("/admin/system/announcement/add", data);
}

/**
 * 删除系统公告
 */
export function deleteSystemAnnouncement(id: number): Promise<void> {
    return httpClient.post(`/admin/system/announcement/delete/${id}`);
}

/**
 * 获取系统公告列表
 */
export function getSystemAnnouncementList(
    pageNo: number,
    pageSize: number,
): Promise<{ items: SystemAnnouncementDTO[]; totalCount: number }> {
    return httpClient.get("/admin/system/announcement/list", { pageNo, pageSize });
}

/**
 * 更新系统公告
 */
export function updateSystemAnnouncement(
    params: Omit<SystemAnnouncementDTO, "dateCreated">,
): Promise<SystemAnnouncementDTO> {
    return httpClient.post("/admin/system/announcement/update", params);
}

/**
 * 获取顶部通知
 */
export function getTopNotification(): Promise<TopNotificationDTO> {
    return httpClient.get("/system/setting/topNotification");
}

/**
 * 管理系统 设置顶部通知
 */

export function setTopNotification(data: TopNotificationDTO) {
    return httpClient.post("/admin/system/setting/updateTopNotification", data);
}
